const theme_menu = {
  els: [],
  data: {},
  init: () => {
    theme_menu.els = $('div[data-theme-menu-id]');
    if (theme_menu.els.length == 0) return;

    let menu_data = false;
    let menu_flag = false;
    if (typeof Storage !== 'undefined') {
      menu_data = localStorage.getItem('theme-menu') || false;
      menu_flag = localStorage.getItem(window.kef.theme_menu.data_url) || false;
    }
    menu_data = false;
    menu_flag = false;

    if (menu_flag !== false && menu_data !== false) {
      theme_menu.data = JSON.parse(menu_data);
      theme_menu.initEl();
    } else {
      localStorage.removeItem('theme-menu');
      $.ajax({
        url: window.kef.theme_menu.data_url,
      }).done((data, status, xhr) => {
        localStorage.setItem(window.kef.theme_menu.data_url, true);
        localStorage.setItem('theme-menu', JSON.stringify(data));
        theme_menu.data = data;
        theme_menu.initEl();
      }).fail((xhr, status, err) => {
  
      }).always((data, status, xhr) => {
  
      });
    }
  },
  initEl: () => {
    let el = null,
        id = '',
        ids = [],
        tpl = null,
        fn = '',
        hb_tpl = null,
        hb_data = {};
    
    theme_menu.els.each((i, e) => {
      el = $(e);
      id = el.data('theme-menu-id');
      fn = el.data('theme-menu-fn');
      locale_key = el.data('theme-menu-locale');
      hb_tpl = $(`#theme-menu-${fn}-hb`);
      hb_data = theme_menu.data[id];

      if (typeof hb_data === 'undefined' || hb_tpl.length == 0) return;

      if (fn == 'header') {
        Handlebars.registerPartial('theme_header_megamenu_shop', $('#theme-header-megamenu-shop-hb').html());
        Handlebars.registerPartial('theme_header_megamenu_about', $('#theme-header-megamenu-about-hb').html());
        Handlebars.registerPartial('theme_header_megamenu_highlight', $('#theme-header-megamenu-highlight-hb').html());

        hb_data.settings.shop_menu_compact = false;
        if (hb_data.menu[0].submenu.filter((item) => item.active).length > 10) {
          hb_data.settings.shop_menu_compact = true;
        }
      } else if (fn == 'drawer') {
        Handlebars.registerPartial('theme_drawer_megamenu_shop', $('#theme-drawer-megamenu-shop-hb').html());
        Handlebars.registerPartial('theme_drawer_megamenu_about', $('#theme-drawer-megamenu-about-hb').html());
        Handlebars.registerPartial('theme_drawer_megamenu_highlight', $('#theme-drawer-megamenu-highlight-hb').html());
      }

      theme_menu.helper.data = hb_data;
      if (ids.indexOf(id) < 0) {
        hb_data = theme_menu.helper.setRecursiveData(hb_data, 'menu', id);
        ids.push(id);
      }
      hb_data = Object.assign(hb_data, {
        texts: general.decodeLocale(window.kef.theme_menu.texts[locale_key]),
        arrow_icon: window.kef.theme_menu.arrow_icon,
        plus_icon: window.kef.theme_menu.plus_icon,
        close_button: window.kef.theme_menu.close_button,
        aria_texts: general.decodeLocale(window.kef.assets.aria.texts),
      });

      tpl = Handlebars.compile(hb_tpl.html());
      el.html(tpl(hb_data));

      fn = `init_menu_${fn}`;
      if (typeof theme_menu[fn] === 'function') theme_menu[fn]();

      // sso
      $('a', el).each(function() {
        var href = $(this).attr('href');
        if (href == '/account') {
          $(this).attr('href', global_fn.getSsoLink('login'));
        } else if (href == '/account/register') {
          $(this).attr('href', global_fn.getSsoLink('register'));
        }
      });

      // localization
      let locale_url = Shopify.routes.root.slice(0,-1);
      $('a', el).each(function() {
        var href = $(this).attr('href');
        if (typeof href !== 'undefined' && href.indexOf('/') == 0 && href.indexOf(locale_url) < 0) {
          if (href.indexOf('#') == 0) {
            // $(this).attr('href', location.pathname+href);
          } else if (href.indexOf('//') == 0) {
            // $(this).attr('href', location.pathname+href);
          } else {
            $(this).attr('href', locale_url+href);
          }
        }
      });
      // var input_country_code = $('input[name="country_code"]'),
      // locale_url = input_country_code.attr('data-url');
      // if (input_country_code.length > 0 && locale_url != '/') {
      //   $('a', el).each(function() {
      //     var href = $(this).attr('href');
      //     if (typeof href !== 'undefined' && href.indexOf('/') == 0 && href.indexOf(locale_url) < 0) {
      //       if (href.indexOf('#') == 0) {
      //         // $(this).attr('href', location.pathname+href);
      //       } else if (href.indexOf('//') == 0) {
      //         // $(this).attr('href', location.pathname+href);
      //       } else {
      //         $(this).attr('href', locale_url+href);
      //       }
      //     }
      //   });
      // }
    });
  },
  init_menu_header: () => {
    const el = $('.shopify-section-header-v3');
    const body = $('body');

    $(window).on('resize', setHeaderMegamenu);
    setHeaderMegamenu();
    function setHeaderMegamenu() {
      var h = $(window).height() - $('.shopify-section-header-announcement').outerHeight() - $('.shopify-section-header-v3').outerHeight();
      if (h > 690) h = 690;
      $('.header-megamenu').css({
        maxHeight: h
      });

      var hh = h - 80 - 45;
      if (hh > 560) hh = 560;
      $('.header-megamenu-shop-products-wrapper').css({
        maxHeight: hh
      });
    }

    body.on('click', function(e) {
      if (e.target.nodeName == 'BODY' && $(e.target).hasClass('header-menu-hover-active')) {
        $('.header-menu-item.active').removeClass('active');
        global_fn.overlay.set('remove', 'header-menu-hover-active');
        e.preventDefault();
      }
    });

    el
      // menu
      .on('click', '.header-menu a', function(e) {
        if ($(this).attr('href')=='#') e.preventDefault();
      })
      .on('click', '.header-menu-item', function(e) {
        if ($(e.target).parents('.header-megamenu-close').length == 0 && $(e.target).parents('.header-menu-item').length == 1) {
          let _t = $(this);
          _t.toggleClass('active').siblings().removeClass('active');
          $(this).hasClass('active')
            ? global_fn.overlay.set('add', 'header-menu-hover-active')
            : global_fn.overlay.set('remove', 'header-menu-hover-active');

          $('.header-megamenu-highlight-menu video', _t).each(function() {
            $(this).get(0).play();
          });
        }
      })
      .on('click', '.header-megamenu-close', function() {
        $('.header-menu-item.active').removeClass('active');
        global_fn.overlay.set('remove', 'header-menu-hover-active');
      })
      // .on('mouseenter', '.header-menu-item', function() {
      //   let _t = $(this);
      //   _t.addClass('active');
      //   global_fn.overlay.set('add', 'header-menu-hover-active');
      // })
      // .on('mouseleave', '.header-menu-item', function() {
      //   let _t = $(this);
      //   _t.removeClass('active');
      //   global_fn.overlay.set('remove', 'header-menu-hover-active');
      // })
      // menu shop
      .on('mouseenter', '.header-megamenu-shop-submenu .header-megamenu-submenu-item, .header-megamenu-shop-products-menu-item', function() {
        let _t = $(this);
        let _r = _t.parents('.header-megamenu-shop-menu');
        let menu_id = _t.data('menu');

        // set active menu
        _t.addClass('active');
        let menu_products = $(`.header-megamenu-shop-products[data-menu="${menu_id}"]`, _r);
        if (menu_products.length == 1) {
          menu_products.addClass('active');
        }
        let menu_lifestyle = $(`.header-megamenu-lifestyle[data-menu="${menu_id}"]`, _r);
        if (menu_lifestyle.length == 1) {
          menu_lifestyle.addClass('active').siblings().removeClass('active');

          let menu_lifestyle_video = $('video', menu_lifestyle);
          if (menu_lifestyle_video.length == 1 && menu_lifestyle_video.is(':visible')) {
            menu_lifestyle_video.get(0).play();
          }
        }

        // hide siblings menu
        if (_t.hasClass('has-products')) {
          _t.siblings().removeClass('active');
          if (menu_products.length == 1) {
            menu_products.siblings().removeClass('active');
          }
        } else {
          _t.siblings(':not(.has-products)').removeClass('active');
        }

        // set min-height menu products
        let submenu = _r.find('.col-header-megamenu-shop-products');
        if (menu_products.length == 1) {
          let h = $('.header-megamenu-shop-products', menu_products).height();
          submenu.css({
            height: h,
          });
        }
      })
      // about shop
      .on('mouseenter', '.header-megamenu-about-menu .header-megamenu-submenu-item', function() {
        let _t = $(this);
        let _r = _t.parents('.header-megamenu-about-menu');
        let menu_id = _t.data('menu');

        // set active menu
        _t.addClass('active').siblings().removeClass('active');
        let menu_lifestyle = $(`.header-megamenu-lifestyle[data-menu="${menu_id}"]`, _r);
        if (menu_lifestyle.length == 1) {
          menu_lifestyle.addClass('active').siblings().removeClass('active');

          let menu_lifestyle_video = $('video', menu_lifestyle);
          if (menu_lifestyle_video.length == 1 && menu_lifestyle_video.is(':visible')) {
            menu_lifestyle_video.get(0).play();
          }
        }
      });

    $('.header-menu-item-wrapper', el).attr('tabindex', 0);
    $('.header-megamenu a', el).attr('tabindex', -1);
    body.on('keydown', function(e) {
      let _t = $(e.target);

      switch (e.key) {
        case 'ArrowRight':
          if (_t.hasClass('header-menu-item-wrapper')) {
            e.preventDefault();
            const $menuItems = $('.header-menu-item-wrapper');
            const index = $menuItems.index(_t);
            const next = (index + 1) % $menuItems.length;
            $menuItems.eq(next).focus();
          } else if (_t.hasClass('header-megamenu-submenu-item')) {
            e.preventDefault();
            const $productMenu = $('.header-megamenu-shop-products.active');
            const $firstProductLink = $productMenu.find('a').first();
            if ($firstProductLink.length) $firstProductLink.focus();
          } else if (_t.closest('.header-megamenu-shop-products').length) {
            e.preventDefault();
            const $items = $('.header-megamenu-shop-products.active a');
            const index = $items.index(_t);
            const next = (index + 1) % $items.length;
            $items.eq(next).focus();
          }
          break;

        case 'ArrowLeft':
          if (_t.hasClass('header-menu-item-wrapper')) {
            e.preventDefault();
            const $menuItems = $('.header-menu-item-wrapper');
            const index = $menuItems.index(_t);
            const prev = (index - 1 + $menuItems.length) % $menuItems.length;
            $menuItems.eq(prev).focus();
          } else if (_t.closest('.header-megamenu-shop-products').length) {
            e.preventDefault();
            const $items = $('.header-megamenu-shop-products.active a');
            const index = $items.index(_t);
            if (index === 0) {
              $('.header-megamenu-submenu-item.active').focus();
            } else {
              $items.eq((index - 1 + $items.length) % $items.length).focus();
            }
          }
          break;

        case 'ArrowDown':
          e.preventDefault();

          // Move into submenu from top nav
          if (_t.hasClass('header-menu-item-wrapper.header-menu-main-shop')) {
            const $submenuFirst = $('.header-megamenu-submenu-item:visible[href]').first();
            if ($submenuFirst.length) $submenuFirst.focus();
            break;
          }

          let $items;
          if (_t.hasClass('header-megamenu-submenu-item')) {
            $items = $('.header-megamenu-submenu-item').filter(':visible[href]');
          } else if (_t.closest('.header-megamenu-shop-products').length) {
            $items = $('.header-megamenu-shop-products.active a').filter(':visible[href]');
          } else {
            return;
          }

          $items.attr('tabindex', '0');

          const downIndex = $items.index(_t);
          if (downIndex === -1) return;

          const nextDownIndex = (downIndex + 1) % $items.length;
          $items.eq(nextDownIndex).focus();
          break;

        case 'ArrowUp':
          e.preventDefault();

          if (_t.closest('.header-megamenu-shop-cta-wrapper').length) {
            $('.header-menu-item-wrapper.header-menu-main-shop').focus();
            break;
          }

          let $upItems;
          if (_t.hasClass('header-megamenu-submenu-item')) {
            $upItems = $('.header-megamenu-submenu-item').filter(':visible[href]');
          } else if (_t.closest('.header-megamenu-shop-products').length) {
            $upItems = $('.header-megamenu-shop-products.active a').filter(':visible[href]');
          } else {
            return;
          }

          $upItems.attr('tabindex', '0');

          const upIndex = $upItems.index(_t);
          if (upIndex === -1) return;

          const prevUpIndex = (upIndex - 1 + $upItems.length) % $upItems.length;
          $upItems.eq(prevUpIndex).focus();
          break;

        case 'Enter':
          if (_t.hasClass('header-menu-item-wrapper')) {
            setTimeout(() => {
              const parentMenu = _t.parent('.header-menu-item');
              if (parentMenu.hasClass('active')) {
                parentMenu.find('.header-megamenu a').attr('tabindex', 0);
                parentMenu.siblings().find('.header-megamenu a').attr('tabindex', -1);
                setScrollElementTabIndex();
              } else {
                parentMenu.find('.header-megamenu a').attr('tabindex', -1);
              }
            }, 100);
          } else if (_t.hasClass('header-megamenu-submenu-item')) {
            let _r = _t.parents('.header-megamenu-shop-menu');
            let menu_id = _t.data('menu');

            if (_t.hasClass('has-products')) {
              e.preventDefault();
            }

            $('.header-megamenu-submenu-item').removeClass('active');
            _t.addClass('active');

            let menu_products = $(`.header-megamenu-shop-products[data-menu="${menu_id}"]`, _r);
            if (menu_products.length == 1) {
              menu_products.addClass('active');
            }

            let menu_lifestyle = $(`.header-megamenu-lifestyle[data-menu="${menu_id}"]`, _r);
            if (menu_lifestyle.length == 1) {
              menu_lifestyle.addClass('active').siblings().removeClass('active');

              let menu_lifestyle_video = $('video', menu_lifestyle);
              if (menu_lifestyle_video.length == 1 && menu_lifestyle_video.is(':visible')) {
                menu_lifestyle_video.get(0).play();
              }
            }

            if (_t.hasClass('has-products')) {
              _t.siblings().removeClass('active');
              if (menu_products.length == 1) {
                menu_products.siblings().removeClass('active');
              }
            } else {
              _t.siblings(':not(.has-products)').removeClass('active');
            }

            let submenu = _r.find('.col-header-megamenu-shop-products');
            if (menu_products.length == 1) {
              let h = $('.header-megamenu-shop-products', menu_products).height();
              submenu.css({ height: h });
            }
          }
          break;
      }
    });
    setScrollElementTabIndex();
    $(window).on('resize', function() {
      setScrollElementTabIndex();
    });
    function setScrollElementTabIndex() {
      $('.header-megamenu-shop-products-wrapper', el).each(function() {
        var _t = $(this);
        if (_t.get(0).scrollHeight > _t.get(0).clientHeight) {
          _t.attr('tabindex', 0);
        } else {
          _t.attr('tabindex', -1);
        }
      });
    }
  },
  init_menu_drawer: () => {
    const el = $('.shopify-section-drawer-v3');
    const body = $('body');
    var scroll_top = 0;

    el
      // menu
      .on('click', '.drawer-menu a', function(e) {
        if ($(this).attr('href')=='#') e.preventDefault();
      })
      .on('click', '.drawer-menu-item.has-submenu[data-mode="dropdown"] > .menu-link', function(e) {
        $(this).parent().toggleClass('active').siblings().removeClass('active');

        e.preventDefault();
      })
      .on('click', 'span.drawer-megamenu-submenu-item[data-mode="dropdown"]', function(e) {
        $(this).toggleClass('active');

        e.preventDefault();
      })
      .on('click', 'a.drawer-megamenu-submenu-item[data-mode="dropdown"] > .svg', function(e) {
        $(this).parent().toggleClass('active');

        e.preventDefault();
      })
      .on('click', '.drawer-megamenu-submenu-item[data-mode="slide"]', function(e) {
        let _t = $(this);
        let _r = _t.parents('.drawer-megamenu');
        let _s = _t.parents('.drawer-megamenu-slide');
        let _c = _t.parents('.drawer-container');

        // set active menu
        let menu_id = _t.data('menu');
        let submenu = $(`.drawer-megamenu-submenu-wrapper[data-menu="${menu_id}"]`, _r);
        if (submenu.length == 1) {
          submenu.addClass('active');
          _t.addClass('active');
          _s.removeClass('active')
            .next().addClass('active');
          scroll_top = _c.scrollTop();
          _c.addClass('active').scrollTop(0);
        }

        e.preventDefault();
      })
      .on('click', '.drawer-megamenu-slide-back-btn', function(e) {
        let _t = $(this);
        let _r = _t.parents('.drawer-megamenu');
        let _s = _t.parents('.drawer-megamenu-slide');
        let _c = _t.parents('.drawer-container');
        let submenu = _t.parents('.drawer-megamenu-submenu-wrapper');

        submenu.removeClass('active');
        _r.prev().removeClass('active');
        _s.removeClass('active')
          .prev().addClass('active');
        _c.removeClass('active').scrollTop(scroll_top);
      });
  },
  init_menu_footer: () => {
    const el = $('.shopify-section-footer-v3');
    const body = $('body');

    body.on('click', function(e) {
      if (! $(e.target).hasClass('social-brand-wechat-toggle')) {
        $('.social-brand-wechat-toggle').removeClass('active');
      }
    });

    el
      // wechat
      .on('click', '.footer-social-channels .social-brand-wechat-toggle', function(e) {
        $(this).toggleClass('active');
      });
  },

  helper: {
    data: {},
    media_ext: {
      image: ['.jpg', '.jpeg', '.gif', '.png'],
      video: ['.mp4'],
    },
    checkMediaExt: (data, exts) => {
      return exts.filter((ext) => {
        return data.indexOf(ext) >= 0;
      }).length > 0;
    },
    setHasLink: (data) => {
      data.has_link = data.hasOwnProperty('link') && (data.link != '' && data.link != 'javascript:void(0);' && data.link != '#');

      return data;
    },
    setHasSubmenu: (data) => {
      data.has_submenu = data.hasOwnProperty('submenu') && data.submenu.length > 0;

      return data;
    },
    setLifestyleData: (data, parent_data) => {
      if (! data.hasOwnProperty('lifestyle')) return data;

      data.has_lifestyle_media = data.lifestyle.media_dt != '';
      data.is_lifestyle_image = theme_menu.helper.checkMediaExt(data.lifestyle.media_dt, theme_menu.helper.media_ext.image);
      data.is_lifestyle_video = theme_menu.helper.checkMediaExt(data.lifestyle.media_dt, theme_menu.helper.media_ext.video);
      data.lifestyle.media_tb = data.lifestyle.media_tb || data.lifestyle.media_dt;
      data.lifestyle.media_mb = data.lifestyle.media_mb || data.lifestyle.media_tb;

      data.lifestyle.media_dt = data.lifestyle.media_dt != '' ? window.kef.theme_menu.asset_url + data.lifestyle.media_dt : '';
      data.lifestyle.media_tb = data.lifestyle.media_tb != '' ? window.kef.theme_menu.asset_url + data.lifestyle.media_tb : '';
      data.lifestyle.media_mb = data.lifestyle.media_mb != '' ? window.kef.theme_menu.asset_url + data.lifestyle.media_mb : '';

      if (parent_data.hasOwnProperty('lifestyle')) {
        if (data.lifestyle.media_alt_text == '' && parent_data.lifestyle.hasOwnProperty('media_alt_text') && parent_data.lifestyle.media_alt_text != '') {
          data.lifestyle.media_alt_text = parent_data.lifestyle.media_alt_text;
        }
        // if (data.lifestyle.text == '' && parent_data.lifestyle.hasOwnProperty('text') && parent_data.lifestyle.text != '') {
        //   data.lifestyle.text = parent_data.lifestyle.text;
        // }
      }

      return data;
    },
    setImageData: (data) => {
      if (! data.hasOwnProperty('media_dt')) return data;

      data.has_media = data.media_dt != '';
      data.media_tb = data.media_tb || data.media_dt;
      data.media_mb = data.media_mb || data.media_tb;

      data.media_dt = data.media_dt != '' ? window.kef.theme_menu.asset_url + data.media_dt : '';
      data.media_tb = data.media_tb != '' ? window.kef.theme_menu.asset_url + data.media_tb : '';
      data.media_mb = data.media_mb != '' ? window.kef.theme_menu.asset_url + data.media_mb : '';

      return data;
    },
    setLabelData: (data) => {
      if (! data.hasOwnProperty('label')) return data;

      data.has_label = data.label != '';

      return data;
    },
    setDrawerData: (data) => {
      if (! data.hasOwnProperty('drawer_mode')) return data;
      else if (data.drawer_mode == '') return data;

      data.is_drawer_slide = data.drawer_mode == 'slide';
      data.is_drawer_dropdown = data.drawer_mode == 'dropdown';

      return data;
    },
    setMenuType: (data, key, id) => {
      if (! data.hasOwnProperty('type')) return data;

      if (id == 'header' && key == 'menu') {
        data.is_shop_menu = data.type == 'shop';
        data.is_about_menu = data.type == 'about';
        data.is_highlight_menu = data.type == 'highlight';
      } else if (id == 'header' && key == 'submenu') {
        // shop
        data.is_products_menu = data.type == 'products';
        data.is_divider_menu = data.type == 'divider';
        // highlight
        data.is_highlight_menu = data.type == 'highlight';
        data.is_list_menu = data.type == 'list';
      }

      return data;
    },
    setRecursiveData: (data, key, id) => {
      for (const i in data[key]) {
        let data_tmp = data[key][i];

        data[key][i] = theme_menu.helper.setHasLink(data_tmp);
        data[key][i] = theme_menu.helper.setHasSubmenu(data_tmp);
        data[key][i] = theme_menu.helper.setLifestyleData(data_tmp, data);
        data[key][i] = theme_menu.helper.setImageData(data_tmp);
        data[key][i] = theme_menu.helper.setLabelData(data_tmp);
        data[key][i] = theme_menu.helper.setDrawerData(data_tmp);
        data[key][i] = theme_menu.helper.setMenuType(data_tmp, key, id);
  
        if (data[key][i].hasOwnProperty('submenu')) {
          data[key][i] = theme_menu.helper.setRecursiveData(data[key][i], 'submenu', id);
        }
      }

      return data;
    },
  }
};

const hb = {
  initHelper: () => {
    Handlebars.registerHelper('slug', (...str) => {
      let options = str.pop(); // remove last str = handlebars options

      let slug_str = String(str.join(' '))
        .trim()
        .toLowerCase()
        .replace(/<[^>]*>?/gm, '')
        .replace(/[^\w ]+/g, '')
        .replace(/ +/g, '-');

      if (slug_str != '') {
        slug_str = String(str.join(' '))
          .trim()
          .toLowerCase()
          .replace(/ +/g, '-');
      }

      return slug_str;
    });
    Handlebars.registerHelper('ifCond', (v1, operator, v2, options) => {
      var flag = false;
      switch (operator) {
        case '==':
          flag = (v1 == v2);
          break;
        case '===':
          flag = (v1 === v2);
          break;
        case '!=':
          flag = (v1 != v2);
          break;
        case '!==':
          flag = (v1 !== v2);
          break;
        case '<':
          flag = (v1 < v2);
          break;
        case '<=':
          flag = (v1 <= v2);
          break;
        case '>':
          flag = (v1 > v2);
          break;
        case '>=':
          flag = (v1 >= v2);
          break;
        case '&&':
          flag = (v1 && v2);
          break;
        case '||':
          flag = (v1 || v2);
          break;
        case 'contains':
          flag = (v1.indexOf(v2) >= 0);
          break;
        case 'not_contains':
          flag = (v1.indexOf(v2) < 0);
          break;
        default:
          flag = false;
          break;
      }

      return flag;
      // return flag ? options.fn(this) : options.inverse(this);
    });
    Handlebars.registerHelper('dataAttr', (data_attrs, options) => {
      data_attrs = data_attrs || {};
      let data_str = '';
      Object.keys(data_attrs).forEach((i) => {
        data_str += ` data-${i}="${data_attrs[i]}"`;
      });
      return data_str;
    });
    Handlebars.registerHelper('default', (val, default_val, options) => {
      return val || default_val;
    });
  }
}

const fa = {
  hexToString: function(hex) {
    if (!hex.match(/^[0-9a-fA-F]+$/)) {
      throw new Error('is not a hex string.');
    }
    if (hex.length % 2 !== 0) {
      hex = '0' + hex;
    }
    var bytes = [];
    for (var n = 0; n < hex.length; n += 2) {
      var code = parseInt(hex.substr(n, 2), 16);
      bytes.push(code);
    }
    return bytes;
  },
  encode: function(data_signature) {
    var signature = base64.encode(this.hexToString(data_signature));
    return signature;
  }
}

const wcag = {
  colorContrast: {
    get: (color) => {
      const rgb = wcag.colorContrast.convertColor(color);

      // luminance of inputted colour
      const L = 0.2126 * wcag.colorContrast.colourMod(rgb.r) + 0.7152 * wcag.colorContrast.colourMod(rgb.g) + 0.0722 * wcag.colorContrast.colourMod(rgb.b);
      
      // white has a luminance of 1
      const whiteL = 1;
      
    // contrast calculation
      const contrast = (whiteL + 0.05) / (L + 0.05);
      
      // return white or black depending on the contrast calculation
      return contrast > 4.5 ? '#fff' : '#000';
    },
    getByBackground(img_el, content_width, content_height, callback) {
      let img_url = img_el.attr('src') || '';
      if (img_url == '') {
        callback('#000');
        return;
      }

      const img = new Image();
      img.crossOrigin = "anonymous"; // Important for loading images from different origins
      img.src = img_url;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img_width = img.naturalWidth || img.offsetWidth || img.width;
        const img_height = img.naturalHeight || img.offsetHeight || img.height;
        canvas.width = img_width;
        canvas.height = img_height;
        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        let totalLuminance = 0;
        let total_pixels = imageData.data.length;
        total_pixels = Math.ceil(img_width * (content_height * img_width / content_width)) * 4;
        for (let i = 0; i < total_pixels; i+=4) {
            const r = imageData.data[i];
            const g = imageData.data[i + 1];
            const b = imageData.data[i + 2];
            // Calculate luminance (using REC. 709)
            const luminance = ((0.299 * r) + (0.587 * g) + (0.114 * b));
            totalLuminance += luminance || 0;
        }

        let averageLuminance = totalLuminance / (imageData.data.length / 4);
        averageLuminance = totalLuminance / parseInt(total_pixels / 4);
        // console.log(img_el[0], averageLuminance);

        callback(averageLuminance > 170 ? '#000' : '#fff');
      };
    },
    colourMod: (colour) => {
      // convert colour in range 0-255 to the modifier used within luminance calculation 
      const sRGB = colour / 255;
      let mod = Math.pow((sRGB + 0.055) / 1.055, 2.4);
      if (sRGB < 0.03928) mod = sRGB / 12.92;
      return mod
    },
    convertColor: (color) => {
      if (color[0] == '#') {
        return wcag.colorContrast.convertHex(color);
      } else {
        return wcag.colorContrast.convertRGB(color);
      }
    },
    convertRGB: (rgb) => {
      // split rgb string into array
      const result = /^rgb\(?([\d]{1,3}), ([\d]{1,3}), ([\d]{1,3})\)$/i.exec(rgb);
      return {
        r: parseInt(result != null ? result[1] : 0, 10),
        g: parseInt(result != null ? result[2] : 0, 10),
        b: parseInt(result != null ? result[3] : 0, 10)
      }
    },
    convertHex: (hex) => {
      // convert '#678ab4' to [r, g, b] format
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
      });
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result != null ? result[1] : 0, 16),
        g: parseInt(result != null ? result[2] : 0, 16),
        b: parseInt(result != null ? result[3] : 0, 16)
      } : null;
    }
  }
}

const global_fn = {
  initCssVars: () => {
    setTimeout(() => {
      const arrs = {
        '--header-height': $('#header').outerHeight(),
        '--header-announcement-height': $('.shopify-section-header-announcement').outerHeight(),
        '--header-v3-height': $('#header .header-wrapper').outerHeight(),
        
        '--sticky-menu-height': $('.sticky-menu-section').outerHeight() ?? 0,
      }
      Object.keys(arrs).forEach((key) => {
        let value = arrs[key];
        document.body.style.setProperty(key, `${value}px`);
      });
    }, 100);
  },
  initHeader: () => {
    const el = $('.shopify-section-header-v3');
    const body = $('body');

    el
      // search
      .on('click', '.header-action-search', function() {
        let _t = $(this);
        _t.addClass('active');
        $('.header-search').addClass('active');
        global_fn.overlay.set('add', 'search-bar-active');

        $(document).trigger({
          type: 'overlay_open',
        });
      })
      .on('click', '.header-action-search.active', function() {
        let _t = $(this);
        _t.removeClass('active');
        $('.header-search').removeClass('active');
        global_fn.overlay.set('remove', 'search-bar-active');

        $(document).trigger({
          type: 'overlay_close',
        });
      })
      .on('click', '.header-search .search-bar-close', function() {
        $('.header-action-search.active').removeClass('active');
        $('.header-search').removeClass('active');
        global_fn.overlay.set('remove', 'search-bar-active');

        $(document).trigger({
          type: 'overlay_close',
        });
      })
      .on('click', '.header-search.active', function(e) {
        if ($(e.target).hasClass('header-search')) {
          $('.header-action-search.active').removeClass('active');
          $('.header-search').removeClass('active');
          global_fn.overlay.set('remove', 'search-bar-active');
  
          $(document).trigger({
            type: 'overlay_close',
          });
        }
      })
      // store locator
      .on('click', '.header-action-store-locator', function(e) {
      })
      // mini cart
      .on('click', '.header-action-cart', function(e) {
      })
      // account
      .on('click', '.header-action-account', function() {
        $('.customer-quick-panel').addClass('active');
        global_fn.overlay.set('add', 'customer-quick-panel-active');
      })
      // drawer
      .on('click', '.header-action-drawer', function() {
        $('.drawer-mobile').toggleClass('active');
        global_fn.overlay.set('toggle', 'drawer-mobile-active');
      });
  },
  initDrawer: () => {
    const el = $('.shopify-section-drawer-v3');
    const body = $('body');

    el
      .on('click', '.drawer-action-close button', function(e) {
        $('.drawer-mobile').removeClass('active');
        global_fn.overlay.set('remove', 'drawer-mobile-active');
      });
  },
  initFooter: () => {
    const el = $('.shopify-section-footer-v3');
  },
  initRegionSelector: () => {
    const body = $('body');

    body.on('click', function(e) {
      if (e.target.nodeName == 'BODY' && $(e.target).hasClass('region-selector-popup-active')) {
        global_fn.overlay.set('remove', 'region-selector-popup-active');
        e.preventDefault();
      }
    });
    
    body
      .on('click', '.region-selector button', function() {
        global_fn.overlay.set('add', 'region-selector-popup-active');
      })
      .on('click', '.region-selector-popup .region-selector-close-btn', function(e) {
        global_fn.overlay.set('remove', 'region-selector-popup-active');
      })
      ;
  },
  initLanguageSelector: () => {
    if (typeof langify === 'undefined') return;

    const body = $('body');
    
    const ivt = setInterval(function() {
      if (typeof langify.helper !== 'undefined') {
        clearInterval(ivt);

        let cur = langify.helper.getCurrentLanguage();
        if (! langify.helper.getCookie('ly-lang-selected')) {
          langify.helper.setCookie('ly-lang-selected', cur, 365);
        }

        $('.language-selector .language-item a').each(function() {
          let key = $(this).data('key').toLowerCase(),
              txt = $(this).text();
          
          $(this).text(window.kef.assets.language[key] || txt);
        });

        body
          .on('click', '.language-selector .language-item a', function(e) {
            let key = $(this).data('key');
            langify.helper.setCookie('ly-lang-selected', key, 365);

            localStorage.removeItem('theme-menu');

            window.location.href = $(this).attr('href');
            e.preventDefault();
          });
      }
    }, 500);
  },
  initLocalizationSelector: () => {
    const body = $('body');

    body.on('click', function(e) {
      if (e.target.nodeName == 'BODY' && $(e.target).hasClass('localization-popup-active')) {
        global_fn.overlay.set('remove', 'localization-popup-active');
        e.preventDefault();
      }
    });

    body
      .on('click', '.localization-selector button', function(e) {
        global_fn.overlay.set('add', 'localization-popup-active');
      })
      .on('click', '.localization-popup .localization-close-btn', function(e) {
        global_fn.overlay.set('remove', 'localization-popup-active');
      })
      .on('click', '.localization-popup .localization-item', function(e) {
        var iso2 = $(this).attr('data-iso2');
        var form = $('#localization_form');
        $('input[name="country_code"]', form).val(iso2);
        form.submit();
        
        e.preventDefault();
      });
  },
  getSsoLink: (type) => {
    return window.kef.sso[type] || '';
  },
  setScrollTo: (timeout = 0, el) => {
    el = el || $('body');
    var hash = window.location.hash.replace('#', '');
    var anchor =  $('a[name="'+hash+'"]', el);
    if (hash != '' && anchor.length > 0) {
      var buffer = $('#header').outerHeight();
      buffer += $('div[class*="sticky-menu-section"]').outerHeight() || 0;
      buffer += 20;
      
      setTimeout(function() {
        $('html,body').stop().animate({
          scrollTop: anchor.offset().top - buffer,
        }, 300);
      }, timeout);
    }
  },

  overlay: {
    classnames: [
      'header-menu-hover-active',
      'search-bar-active',
      'drawer-mobile-active',
      'minicart-active',
      'customer-quick-panel-active',
      'region-selector-popup-active',
      'localization-popup-active',
    ],
    set: (action, class_name) => {
      const body = $('body');

      if (action == 'add') {
        body.addClass(class_name);
        body.addClass('overlay-active');
      } else if (action == 'remove') {
        body.removeClass(class_name);
        global_fn.overlay.toggle(false);
      } else if (action == 'toggle') {
        body.toggleClass(class_name);
        global_fn.overlay.toggle(true);
      }
    },
    toggle: (is_toggle = false) => {
      const body = $('body');
      
      let flag = true;
      global_fn.overlay.classnames.forEach((classname) => {
        if (body.hasClass(classname)) flag = false;
      });

      if (flag) body.removeClass('overlay-active');
      else if (!flag && is_toggle) body.toggleClass('overlay-active');
    },
  },

  scroll: {
    supportsPassive: false,
    wheelOpt: false,
    wheelEvent: 'wheel',
    preventDefault: (e) => {
      e.preventDefault();
    },
    preventDefaultForScrollKeys: (e) => {
      var keys = {37: 1, 38: 1, 39: 1, 40: 1};
      if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
      }
    },
    init: () => {
      var supportsPassive = false;
      try {
        window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
          get: function () { supportsPassive = true; } 
        }));
      } catch(e) {}
      var wheelOpt = supportsPassive ? { passive: false } : false;
      var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

      global_fn.scroll.supportsPassive = supportsPassive;
      global_fn.scroll.wheelOpt = wheelOpt;
      global_fn.scroll.wheelEvent = wheelEvent;
    },
    disable: () => {
      window.addEventListener('DOMMouseScroll', global_fn.scroll.preventDefault, false);
      window.addEventListener(global_fn.scroll.wheelEvent, global_fn.scroll.preventDefault, global_fn.scroll.wheelOpt);
      window.addEventListener('touchmove', global_fn.scroll.preventDefault, global_fn.scroll.wheelOpt);
      window.addEventListener('keydown', global_fn.scroll.preventDefaultForScrollKeys, false);
    },
    enable: () => {
      window.removeEventListener('DOMMouseScroll', global_fn.scroll.preventDefault, false);
      window.removeEventListener(global_fn.scroll.wheelEvent, global_fn.scroll.preventDefault, global_fn.scroll.wheelOpt); 
      window.removeEventListener('touchmove', global_fn.scroll.preventDefault, global_fn.scroll.wheelOpt);
      window.removeEventListener('keydown', global_fn.scroll.preventDefaultForScrollKeys, false);
    },
  },

}

const general = {
  initHeaderScroll: function() {
    var H = 0;
    $(window).on('ready load scroll', function() {
      var body = $('body');
      var header = $('#header');
      var footer = $('#footer');
      var h = $(this).scrollTop();

      if (h <= header.outerHeight()) {
        body.addClass('scrolled-header');
        body.removeClass('scroll-top');
        body.removeClass('scroll-btm');
        body.removeClass('scroll-footer');
        return false;
      }

      body.removeClass('scrolled-header');
      if (footer.length > 0) {
        var footer_top = footer.offset().top - (window.outerHeight / 2)
        if (h >= footer_top) {
          body.addClass('scroll-footer');
        } else {
          body.removeClass('scroll-footer');
        }
      }

      if ($('body').hasClass('template-product')) {
        var cms = $('.product-cms-container').offset();
        if (H > h || h <= (cms.top - header.outerHeight() - 100)) {
          body.addClass('scroll-top');
          body.removeClass('scroll-btm');
        } else {
          body.removeClass('scroll-top');
          body.addClass('scroll-btm');
        }
      } else {
        if (H > h) {
          body.addClass('scroll-top');
          body.removeClass('scroll-btm');
        } else {
          body.removeClass('scroll-top');
          body.addClass('scroll-btm');
        }
      }

      H = h;
    });
  },
  initBackToTop: function() {
    var H = 0;
    var el = $('#back-to-top');
    var anchor = $('a[name="back-to-top"]');
    el.on('click', function() {
      var header = $('#header');
      var scrollTop = (anchor.length > 0 ? anchor.offset().top : 0) - header.outerHeight();
      $('html, body').stop().animate({
        scrollTop: scrollTop < 0 ? 0 : scrollTop
      }, 300);
    });
    $(window).scroll(onScroll);
    onScroll();
    function onScroll() {
      var header = $('#header');
      var h = $(window).scrollTop();

      if (h <= header.outerHeight()) {
          el.removeClass('active');
      } else {
          el.addClass('active');
      }

      H = h;
    }
  },
  redirectProperUrl: function() {
    var hash = window.location.hash;
    if (hash.indexOf('?') >= 0) {
      var arr = hash.split('?');
      var new_url = window.location.pathname + '?' + arr[1] + arr[0];
      window.location.href = new_url;
    }
  },
  getUrlVars: function(search) {
    var vars = {};
    var parts = (search || window.location.search).replace(/[?&]+([^=&]+)=([^&]*)/gi,    
    function(m,key,value) {
      vars[key] = value;
    });
    return vars;
  },
  decodeEntity: function(val) {
    var textarea = document.createElement("textarea");
    textarea.innerHTML = val;
    return textarea.value;
  },
  decodeLocale: function(json_string) {
    return JSON.parse(general.decodeEntity(json_string).replaceAll('=>',":"));
  },
  copyText: function(val) {
    var _t = $(this);
    val = val || _t.text();
    copyText(val);

    _t.addClass('active');
    setTimeout(function() {
      _t.removeClass('active');
    }, 3000);
    
    function copyText(text) {
      copyTextToClipboard(text);
    }
    
    function fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;
      
      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
    
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
    
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
      } catch (err) {
      }
    
      document.body.removeChild(textArea);
    }
    
    function copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(function() {
      }, function(err) {
      });
    }
  },
  // cms
  initCmsFn: function() {
    $('.cms_editable_block a[href*="/products/"] img').each(function() {
      $(this).parent()
        .addClass('cms-product-slide-v2-img-link')
        .siblings('.cms_button[href*="/products/"]').addClass('cms-product-slide-v2-btn-shop')
        .siblings('.cms_link[href*="/pages/"]').addClass('cms-product-slide-v2-btn-explore');
    });

    $('.cms_accordion').each(function() {
      $(this).addClass('kef-cms-accordion');
      $('.title-box', this).addClass('kef-cms-accordion-title-box');
      $('.title-box .title', this).addClass('kef-cms-accordion-title');
      $('.title-box .icon', this).addClass('kef-cms-accordion-title-icon');
      $('.contents-box', this).addClass('kef-cms-accordion-contents-box');
      $('.contents', this).addClass('kef-cms-accordion-contents');
    });
  },
  setEqualContentHeight: function(column_target, el_target, row_target) {
    // set row > column > "div content" equal height
    row_target = row_target || '.basic_column-equal-content-height';
    column_target = column_target || '> .basic_column';
    el_target = el_target || '> div';

    if (column_target == '' || el_target == '') return false;

    $(row_target+' '+column_target+' '+el_target).removeAttr('style');
    $(row_target).each(function() {
      var H = [];
      //  get height
      $(column_target, this).each(function() {
        $(el_target, this).each(function(i) {
          var this_H = H[i] || 0;
          var h = $(this).outerHeight();
          if (h > this_H) this_H = h;
          H[i] = this_H;
        });
      });
      //  set height
      $(column_target, this).each(function() {
        $(el_target, this).each(function(i) {
          var this_H = H[i] || 0;
          if (this_H == 0) return;

          $(this).css({
            height: this_H
          });
        });
      });
    });
  },
  // custom code
  initCard: function() {
    var el = $('.kef-card');
    if (el.length == 0) return;

    if (el.hasClass('kef-card-has-btn') && el.hasClass('kef-card-hover')) {
      var aria_texts = general.decodeLocale(window.kef.assets.aria.texts);
      $('.kef-card-has-btn.kef-card-hover .kef-card-btn').attr('aria-label', aria_texts.close);

      $('.kef-card-has-btn.kef-card-hover').on('click', '.kef-card-btn', function(e) {
        $(this).toggleClass('active').parents('.kef-card').toggleClass('active');
        e.preventDefault();
      });
      $('.kef-card-has-btn.kef-card-hover').on('click', '.kef-card-front', function(e) {
        $(this).parents('.kef-card').toggleClass('active');
        $(this).parents('.kef-card').find('.kef-card-btn').toggleClass('active');
        e.preventDefault();
      });
    }
  },
  initVideo: function() {
    var el = $('.kef-video');
    if (el.length == 0) return;

    if (el.hasClass('kef-video-has-btn')) {
      $('.kef-video-has-btn').on('click', '.kef-video-btn', function(e) {
        $(this).toggleClass('active')
        var video = $(this).parents('.kef-video').find('video');
        if (video.length == 0) return;

        video = video.get(0);
        video.paused ? video.play() : video.pause();
        e.preventDefault();
      });
    }

    if (el.hasClass('kef-video-scrollplay')) {
      $(window).scroll(function() {
        var T = $(this).scrollTop(),
            videos = $('.kef-video');
        
        videos.each(function(i, e) {
          var el = $(e),
              h = el.height(),
              t = el.offset().top - (h/2);
          
          var video = $('video', el);
          if (video.length == 0) return;

          video = video.get(0);
          if (T > t && video.paused) {
            $('.kef-video-btn', el).trigger('click');
          }
          // T > t && video.paused ? video.play() : video.pause();
        });
      });
    }
  },
  initStickyMenuSection: function(sticky_menu_id) {
    sticky_menu_id = sticky_menu_id || 'div[id*="sticky-menu"]';
    var sticky_menu = $(sticky_menu_id);
    if (sticky_menu.length == 0) return;
    
    var style = document.createElement('link');
    style.href = window.kef.assets.sticky_menu.css;
    style.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(style);

    var script = document.createElement('script');
    script.src = window.kef.assets.sticky_menu.js;
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
  },
  initKefSwiper: function() {
    var carousels = $('.kef-swiper');
    if (carousels.length == 0) return;

    var style = document.createElement('link');
    style.href = window.kef.assets.swiper.css;
    style.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(style);

    var script = document.createElement('script');
    script.src = window.kef.assets.swiper.js;
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
  },
  initKefTableComparison: function() {
    var tables = $('.kef-table-comparison');
    if (tables.length == 0) return;

    var style = document.createElement('link');
    style.href = window.kef.assets.table_comparison.css;
    style.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(style);

    var script = document.createElement('script');
    script.src = window.kef.assets.table_comparison.js;
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
  },
  initKefHotspots: function() {
    var hotspots = $('.kef-hotspots');
    if (hotspots.length == 0) return;

    var style = document.createElement('link');
    style.href = window.kef.assets.hotspots.css;
    style.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(style);

    var script = document.createElement('script');
    script.src = window.kef.assets.hotspots.js;
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
  },
  initKefVideoSequence: function() {
    var video_sequences = $('.kef-video-sequence');
    if (video_sequences.length == 0) return;

    var style = document.createElement('link');
    style.href = window.kef.assets.video_sequence.css;
    style.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(style);

    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/video-worker@2/dist/video-worker.min.js';
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);

    script.onload = function() {
      var script2 = document.createElement('script');
      script2.src = window.kef.assets.video_worker.js;
      script2.type = 'text/javascript';
      document.getElementsByTagName('head')[0].appendChild(script2);

      script2.onload = function() {
        var script3 = document.createElement('script');
        script3.src = window.kef.assets.video_sequence.js;
        script3.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(script3);
      }
    }
  },
  initVideoSequence: function(video_el, scene_div_classname) {
    // <script src="https://unpkg.com/@agilie/canvas-image-cover-position"></script>
    // <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.0/gsap.min.js"></script>
    // <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.0/ScrollTrigger.js"></script>
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return false;

    gsap.registerPlugin(ScrollTrigger);
    // ScrollTrigger.saveStyles('.aos-element');
    ScrollTrigger.config({
      autoRefreshEvents: "visibilitychange,DOMContentLoaded,load,resize"
    });

    //  canvas scane
    var scenes = {};
    var vid_seq_el = $(video_el);
    if (vid_seq_el.length == 0) return;

    var scale = 1; 
    vid_seq_el.each(function(i, el) {
      canvas = document.createElement('canvas');
      canvas.width = document.documentElement.clientWidth * scale;
      canvas.height = window.innerHeight * scale;
      context = canvas.getContext("2d");
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = "high";
      if (scale > 1) context.scale(scale, scale);

      var el = $(this),
          container = el.parents(scene_div_classname),
          container_id = container.attr('id');

      var data = {
        totalFrame: el.data('total-frame'),
        totalFramePerSecond: el.data('total-frame-per-second') || 30,
        dataFolder: el.data('folder'),
        dataFolderTb: el.data('folder-tb'),
        dataFolderMb: el.data('folder-mb'),
        dataFilename: el.data('filename'),
        dataSequencePad: el.data('sq-pad'),
      };
      
      var img = new Image();
      img.src = getImg(0, data, getSize());

      var scene = {
        frame: 0,
        id: container_id,
        container: container,
        canvas: canvas, 
        context: context, 
        images: [img],
        current_img: img,
        data: data,

        is_fullwidth: typeof el.data('fullwidth') !== 'undefined' ? el.data('fullwidth') : true,
        is_fullheight: typeof el.data('fullheight') !== 'undefined' ? el.data('fullheight') : true,
        is_scroll_fullheight: typeof el.data('scroll-fullheight') !== 'undefined' ? el.data('scroll-fullheight') : true,
      }

      scenes[container_id] = scene;

      img.onload = render(scene, true);

      //  insert canvas html
      container.prepend(canvas);
      $(this).parent().remove();
    });
    
    $(window).on('resize', function() {
      render();
    }).on('load', function() {
      initCanvas();
      //  scroll back on load
      setTimeout(function() {
        if ($('#header').offset().top > 0) {
          $('body, html').scrollTop(0);
          ScrollTrigger.refresh();
        }
      }, 100);
    }).on('scroll', function() {
    });

    function initCanvas() {
      $.each(scenes, function(i, scene) {
        $('.aos-element', scene.container).each(function() {
          // gsap.utils.toArray('.aos-element').forEach(function(target, idx) {
            var target = this,
                start = scene.is_fullwidth ? "center 50%" : "bottom bottom",
                end = scene.is_fullwidth ? "bottom top" : "top top";
            gsap.timeline({
              scrollTrigger: {
                trigger: target,
                markers: false,
                scrub: true,
                pin: false,
                start: start,
                end: end,
              }
            })
            .fromTo(target, {y: 25}, {y: -25})
            .from(target, {opacity: 0, duration: 0.2}, 0)
            .to(target, {opacity: 0, duration: 0.2}, 0.8);
          });
      });
    
      var size = getSize();
      gsap.utils.toArray(scene_div_classname).forEach(function(el, idx) {
        var scene = scenes[$(el).attr('id')];
        if (typeof scene === 'undefined') return;
        for (var i = 1; i < scene.data.totalFrame; i++) {
          var img = new Image();
          img.src = getImg(i, scene.data, size);
          scene.images.push(img);
        }
    
        var scrollTriggerParams = {
          trigger: "#"+scene.id,
          scrub: 0.5,
        };
    
        if (size == 'mb') {
          if (scene.is_scroll_fullheight) {
            scrollTriggerParams.start = "top 20%";
            scrollTriggerParams.end = "bottom 50%";
          } else {
            scrollTriggerParams.start = "bottom 130%";
            scrollTriggerParams.end = "top top";
          }
        } else {
          if (scene.is_scroll_fullheight) {
            scrollTriggerParams.start = "top top";
            scrollTriggerParams.end = "bottom center";
          } else {
            scrollTriggerParams.start = "bottom 120%";
            scrollTriggerParams.end = "top top";
          }
        }
    
        scene.gsap = gsap.to(scene, {
          frame: scene.data.totalFrame - 1,
          snap: 'frame',
          ease: 'none',
          scrollTrigger: scrollTriggerParams,
          onUpdate: render
        });
    
        scene.images[0].onload = render(scene, true);
        
        scene.container.addClass('page-video-sequence');
      });
    }
    
    function getImg(index, data, size) {
      var folder = data.dataFolder;
      if (size == 'mb') folder = data.dataFolderMb;
      else if (size == 'tb') folder = data.dataFolderTb;
    
      var filename = data.dataFilename.replace('[sq]', (index).toString().padStart(data.dataSequencePad, '0'));
    
      return folder + filename;
    }
    
    function render(scene, render_canvas) {
      render_canvas = render_canvas || false;
      var scenes_loop = (typeof scene !== 'undefined') ? [scene] : scenes;
    
      $.each(scenes_loop, function(i, scene) {
        var context = scene.context,
            canvas = scene.canvas,
            frame = scene.frame,
            images = scene.images;
    
        var img = images[frame],
            first_img = images[0],
            size = getSize();
    
        var flag_canvas = ScrollTrigger.isInViewport(canvas, 0.2),
            flag_img = scene.current_img.src == img.src;
        if (!flag_canvas && !render_canvas) return;
        else if (flag_img && !render_canvas) return;
    
        scenes[scene.id].current_img = scene.current_img = img;
    
        if (size == 'mb') {
          context.canvas.width = scene.is_fullwidth ? document.documentElement.clientWidth : img.naturalWidth;
          var h = img.naturalHeight / (img.naturalWidth > 480 ? 2 : 1);
          var H = window.innerHeight;
          context.canvas.height = scene.is_fullheight ? (h > H ? H : h) : img.naturalHeight;
          context.clearRect(0, 0, canvas.width, canvas.height);
        } else if (size == 'tb') {
          context.canvas.width = scene.is_fullwidth ? document.documentElement.clientWidth : img.naturalWidth;
          var h = img.naturalHeight / 1;
          var H = window.innerHeight;
          context.canvas.height = scene.is_fullheight ? (h > H ? H : h) : img.naturalHeight;
          context.canvas.height = scene.is_fullheight ? window.innerHeight : img.naturalHeight;
          context.clearRect(0, 0, canvas.width, canvas.height);
        } else {
          context.canvas.width = scene.is_fullwidth ? document.documentElement.clientWidth : img.naturalWidth;
          context.canvas.height = scene.is_fullheight ? window.innerHeight : img.naturalHeight;
          context.clearRect(0, 0, canvas.width, canvas.height);
        }
    
        var imageCoverSize = getCoverSize(
          img.naturalWidth,
          img.naturalHeight,
          canvas.width,
          canvas.height,
          0.5,
          0.5
        );
    
        if (!Number.isNaN(imageCoverSize.height) && !Number.isNaN(imageCoverSize.offsetTop)) {
          context.drawImage(img, 
            imageCoverSize.offsetLeft,
            imageCoverSize.offsetTop,
            imageCoverSize.width,
            imageCoverSize.height
          );
        }
    
        if (scene.is_fullwidth) {
          if (render_canvas) renderCanvas(scene);
        }
      });
    }
    
    function renderCanvas(scene) {
      var img = scene.images[0],
          size = getSize();
    
      //  canvas
      var multiplier = (scene.data.totalFrame / scene.data.totalFramePerSecond);
      var canvas_height = (size == 'mb' || size == 'tb')
        ? (img.naturalHeight / (size == 'mb' && img.naturalWidth > 480 ? 2 : 1) * multiplier) + 'px'
        : (100 * multiplier) + 'vh';
      scene.container.css({
        height: canvas_height,
      });
    
      //  text
      var container_height = (size == 'mb' || size == 'tb')
        ? (img.naturalHeight / (size == 'mb' && img.naturalWidth > 480 ? 2 : 1)) + 'px'
        : (100) + 'vh';
      $('.aos-container', scene.container).css({
        height: container_height
      });
    }
    
    function getSize() {
      var size = 'dt';
      if (document.documentElement.clientWidth <= 480) size = 'mb';
      else if (document.documentElement.clientWidth >= 481 && document.documentElement.clientWidth <= 850) size = 'tb';
    
      return size;
    }
  },
  initAudioPlayer: function(video_id, video_play_id, audio_switch_id, container_id) {
    video_id = video_id || '.audio-player-video';
    video_play_id = video_play_id || '.audio-player-video-btn';
    audio_switch_id = audio_switch_id || '.audio-player-tracklist';
    container_id = container_id || '.audio-player';

    var video = $(video_id),
        video_btn = $(video_play_id),
        audio_tracklist = $(audio_switch_id),
        container = $(container_id);
    if (video.length == 0 || audio_tracklist.length == 0) return;

    // tracklist
    var tracklist_datas = audio_tracklist.data();
    var tracklist_html = ``;
    var divider = tracklist_datas['tracks'].indexOf('|') >= 0 ? '|' : ',';
    var tracks = tracklist_datas['tracks'].split(divider);
    var labels = tracklist_datas['labels'].split(divider);
    $.each(tracks, function (i, track) {
      var checked = i == 0,
          label = labels[i].trim(),
          id = 'audio-track-'+label.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-')+i;
      tracklist_html += `<div class="audio-track">
        <input type="radio" name="audio-track" value="${id}" id="${id}" data-file="${track}" ${checked ? 'checked' : ''}>
        <label for="${id}">${label}</label>
      </div>`
    });

    var html = `<div>${tracklist_html}</div>`;
    audio_tracklist.parent().addClass('audio-player-tracklist').html(html);

    // video
    // HACK - replace the entire <video> tag to overcome disablepictureinpicture in ios
    // $('video', video).attr('disablePictureInPicture', '')
    //   .attr('controlslist', 'nofullscreeen')
    //   .removeAttr('controls');
    var video_el = $('video', video),
        video_url = video_el.attr('src'),
        video_style = video_el.attr('style');
    video.html(`<video src="${video_url}" style="${video_style}" disablePictureInPicture controlsList="nofullscreen" loop poster muted playsinline webkit-playsinline></video>`);

    // video player
    if (video_btn.length == 0) {
      video.append(`<button type="button" class="audio-player-video-btn"></button>`);
    }

    // initialize
    var player = {
      container: $(container_id),
      video: $(video_id+' video'),
      video_btn: $(video_play_id),
      audio_tracklist: $(audio_switch_id),

      audios: {}
    };

    var dd = false,
        tracks = $('input', player.audio_tracklist),
        total_tracks = tracks.length;

    tracks.each(function() {
      var id = $(this).attr('id'),
          file = $(this).data('file');

      player.audios[id] = new Howl({
        src: [file],
        preload: true,
        loop: true,
        volume: 1,
        xhr: {
          method: 'GET',
        },
        onload: function() {
          if (dd) ddLog(id, player.audios[id], 'loadedmetadata');
          total_tracks--;
          if (total_tracks == 0) player.video_btn.show();
        },
      });
    });

    var playing = false;
    $(function() {
      player.video_btn.on('click', function() {
        if (! playing) {
          playAllAudio();
          player.video[0].play();
          player.video_btn.hide();
        }
        playing = true;
      });
      player.video.on('click', function() {
        if (playing) {
          pauseAllAudio();
          player.video[0].pause();
          player.video_btn.show();
          playing = false;
        }
      });
      // player.video.on('play', playAllAudio);
      // player.video.on('pause', pauseAllAudio);
      // player.video.on('seeked', seekAllAudio);
      // player.video.on('ended', resetAllAudio);
      tracks.on('change', updateAudio);
    });

    function updateAudio() {
      var checked = $('input:checked', player.audio_tracklist);

      var seek = getVideoSeekTime();

      $.each(player.audios, function(id, audio) {
        if (dd) console.log(checked.val(), id)
        player.audios[id].mute(checked.val() != id);
        player.audios[id].seek(seek);

        ddLog(i,  player.audios[id], 'update');
      });
    }

    function pauseAllAudio() {
      $.each(player.audios, function(id, audio) {
        player.audios[id].pause();
        
        ddLog(i,  player.audios[id], 'pause');
      });
      
      playing = false;
    }

    function playAllAudio() {
      if (!playing) {
        $.each(player.audios, function(id, audio) {
          player.audios[id].play();
          
          ddLog(i,  player.audios[id], 'play');
        });
      }
      
      playing = true;

      updateAudio();
    }

    function seekAllAudio() {
      var seek = getVideoSeekTime();
      
      $.each(player.audios, function(i, audio) {
        player.audios[id].seek(seek);

        ddLog(i,  player.audios[id], 'seek');
      });
    }

    function resetAllAudio() {
      $.each(player.audios, function(id, audio) {
        player.audios[id].stop();
        player.audios[id].seek(0);

        ddLog(i,  player.audios[id], 'reset');
      });
    }

    function ddLog(key, howler_obj, log_name) {
      if (dd) console.log(`${new Date} ${key} - ${log_name} - ${howler_obj.muted} - ${howler_obj.playing()} - ${howler_obj.state()}`);
    }

    function getHowlerSeekTime() {
      var seek = Howler.ctx.currentTime,
          first_track = Object.values(player.audios)[0];
      if (seek > first_track.duration()) {
        seek = seek % first_track.duration();
      }

      return seek;
    }

    function getVideoSeekTime() {
      var seek = Math.round(player.video[0].currentTime);

      return seek;
    }
  },
  initReferral: function() {
    if (! window.kef.assets.referral.flag) return;

    var _ref = "SOLREF";
    var _discount = "discount";

    var paramString = window.location.search.split('?')[1];
    var queryString = new URLSearchParams(paramString);

    var ref = queryString.get(_ref);
    var discount = queryString.get(_discount);

    var productObj = document.getElementById('ProductJson-product-template') ? JSON.parse(document.getElementById('ProductJson-product-template').innerHTML) : null;
    var cartObj = document.getElementById('CartJson-cart-template') ? JSON.parse(document.getElementById('CartJson-cart-template').innerHTML) : null;

    if (ref !== null && discount !== null) {
      localStorage.setItem(`${_ref}_BIND`, discount ? discount : "true");
      localStorage.setItem(`${_ref}_PROD`, productObj ? productObj.handle : false);
    }
    if (localStorage.getItem(`${_ref}_BIND`)!==null && ref!==null){
      jQuery.post('/cart/update.js', `attributes[${_ref}]=true`);
    }

    storedDiscount = localStorage.getItem(`${_ref}_BIND`);
    storedHandle = localStorage.getItem(`${_ref}_PROD`);

    var flag = true;

    if (storedDiscount===null || storedDiscount==="true")
      flag = false;
    if (!productObj && !cartObj)
      flag = false;
    if (!storedHandle)
      flag = false;
    if (productObj && productObj.handle!==storedHandle)
      flag = false;

    if (!flag)
      return false;

    var url = `${window.kef.assets.referral.url_path}${_ref}/${storedHandle}/${window.kef.assets.referral.env_folder}/${storedDiscount}/${window.kef.sf_locale}.json`;
    $.ajax({
      type: "GET",
      url: url,
      dataType: "json",
      cache: false
    }).done(function(res){
      if (res.status){
        eval(res.data.callback);
      }
    }).fail(function(){ console.warn( "Warning: Missing locale file" ); });
  },
}

const collections = {
  cardImageNav: function() {
    $('.product-card__image-nav button').on('click', function() {
      var action = $(this).data('action');
      var card = $(this).parent().prev('.product-card');
      var img = card.find('.product-card__image.main');
      var imgs = card.find('.product-card__image');

      var img_main = action == 'prev' ? img.prev() : img.next();
      if (img_main.length == 0) {
        img_main = action == 'prev' ? imgs.last() : imgs.first();
      }

      var img_secondary = img_main.next();
      if (img_secondary.length == 0) {
        img_secondary = imgs.first();
      }

      img.removeClass('main');
      img_main.addClass('main');

      imgs.removeClass('secondary');
      img_secondary.addClass('secondary');
    });
  }
}

const products = {
  redirectCollectionLink: function() {
    var pathname = window.location.pathname;
    if (pathname.indexOf('/collections/') >= 0) {
      window.location.href = '/' + pathname.split('/').slice(3).join('/');
    }
  },

  initLatestOffer: function() {
    var bundles_v1 = $('.product-bundle');

    var bundles_v2 = $('.product-bundle-v2');
    var bundles_v2_multiselectall = $('div[class*="product-bundle-multiselectall-v"]');

    if (bundles_v1.length > 0 || bundles_v2.length > 0 || bundles_v2_multiselectall.length > 0) {
      window.kef.latest_offer_texts = window.kef.assets.latest_offer.texts;
      
      if (bundles_v1.length > 0) {
        var style = document.createElement('link');
        style.rel = 'stylesheet';
        style.type = 'text/css';
        style.href = window.kef.assets.latest_offer.css;
        document.getElementsByTagName('head')[0].appendChild(style);

        var script = document.createElement('script');
        script.src = window.kef.assets.latest_offer.js;
        script.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(script);
      }
      if (bundles_v2.length > 0 || bundles_v2_multiselectall.length > 0) {
        var style = document.createElement('link');
        style.rel = 'stylesheet';
        style.type = 'text/css';
        style.href = window.kef.assets.latest_offer_v2.css;
        document.getElementsByTagName('head')[0].appendChild(style);

        var script = document.createElement('script');
        script.src = window.kef.assets.latest_offer_v2.js;
        script.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    }
  },
  initProductCarousel: function() {
    var carousels = $('.product-carousel-v2');
    if (carousels.length == 0) return;

    window.kef.product_carousel_texts = window.kef.assets.product_carousel.texts;

    var style = document.createElement('link');
    style.href = window.kef.assets.product_carousel.css;
    style.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(style);

    var script = document.createElement('script');
    script.src = window.kef.assets.product_carousel.js;
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
  },
  initProductCollection: function() {
    var els = $('.product-collection-v2');
    if (els.length == 0) return;

    window.kef.product_collections_texts = window.kef.assets.product_collection.texts;

    var style = document.createElement('link');
    style.href = window.kef.assets.product_collection.css;
    style.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(style);

    var script = document.createElement('script');
    script.src = window.kef.assets.product_collection.js;
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
  },
  initProductComparison: function() {
    var els = $('.product-comparison');
    if (els.length == 0) return;

    window.kef.product_comparison = {
      type: window.kef.assets.product_comparison.data_type,
      url: window.kef.assets.product_comparison.data_url,
      texts: JSON.parse(general.decodeEntity(window.kef.assets.product_comparison.texts).replaceAll('=>',':')),
    };

    var style = document.createElement('link');
    style.href = window.kef.assets.product_comparison.css;
    style.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(style);

    var script = document.createElement('script');
    script.src = window.kef.assets.product_comparison.js;
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
  },
}

const cart_fn = {
  get: () => {
    return $.ajax({
      type: 'get',
      url: Shopify.routes.root + 'cart.js',
      cache: false,
      dataType: 'json',
      success: function(cart) {
        minicart_v3.update(cart);
        if (window.template == 'cart') window.location.reload();
      }
  });
  },
  add: (data) => {
    return $.ajax({
      type: 'post',
      url: Shopify.routes.root + 'cart/add.js',
      data: data,
      dataType: 'json',
      success: function(cart) {
        minicart_v3.clearError();
        minicart_v3.open();
        minicart_v3.updateTitle(cart, 'add');
        cart_fn.get();
      },
      error: function(xhr, text) {
        minicart_v3.showError($.parseJSON(xhr.responseText).description);
        minicart_v3.open();
      },
    })
  },
  change: (data) => {
    // `quantity=${q}&id=${id}`
    return $.ajax({
      type: 'post',
      url: Shopify.routes.root + 'cart/change.js',
      data: data,
      dataType: 'json',
      success: function(cart) {
        minicart_v3.clearError();
        if (window.template != 'cart') {
          minicart_v3.open();
        }
        minicart_v3.updateTitle(cart);
        cart_fn.get();
      },
      error: function(xhr, text) {
        minicart_v3.showError($.parseJSON(xhr.responseText).description);
        if (window.template != 'cart') {
          minicart_v3.open();
        }
      },
    })
  },
  update: (data) => {
    return $.ajax({
      type: 'post',
      url: Shopify.routes.root + 'cart/update.js',
      data: data,
      dataType: 'json',
      success: function(cart) {
        minicart_v3.clearError();
        if (window.template != 'cart') {
          minicart_v3.open();
        }
        minicart_v3.updateTitle(cart);
        cart_fn.get();
      },
      error: function(xhr, text) {
        minicart_v3.showError($.parseJSON(xhr.responseText).description);
        if (window.template != 'cart') {
          minicart_v3.open();
        }
      },
    })
  },
}

var ivt_v3 = setInterval(() => {
  if (typeof $ !== 'undefined' && typeof Handlebars !== 'undefined') {
    clearInterval(ivt_v3);
    
    $(() => {
      hb.initHelper();
      theme_menu.init();
  
      global_fn.initHeader();
      global_fn.initDrawer();
      global_fn.initFooter();
      global_fn.initRegionSelector();
      global_fn.initLanguageSelector();
      global_fn.initLocalizationSelector();
  
      global_fn.initCssVars();
      $(window).on('load scroll resize orientationchange', global_fn.initCssVars);
      $(window).on('load hashchange', global_fn.setScrollTo);
      global_fn.scroll.init();
      $(document).on('overlay_open', global_fn.scroll.disable);
      $(document).on('overlay_close', global_fn.scroll.enable);

      general.initHeaderScroll();
      general.initReferral();
      general.redirectProperUrl();
      // cms
      general.initCmsFn();
      general.setEqualContentHeight();
      $(window).on('load resize', function() { general.setEqualContentHeight(); });
      // custom code
     // general.initCard();
      //general.initVideo();
      //general.initStickyMenuSection();
      //general.initKefSwiper();
      //general.initKefTableComparison();
      //general.initKefHotspots();
      //general.initKefVideoSequence();

      collections.cardImageNav();
      if ($('body').hasClass('template-product')) products.redirectCollectionLink();
      // custom code
      products.initLatestOffer();
     // products.initProductCarousel();
     // products.initProductCollection();
     // products.initProductComparison();

      $('.swatch label').each(function() {
        const contrast = wcag.colorContrast.get($(this).css('background-color'));
        $(this).css('color', contrast);
      });
    });
  }
}, 500);